import script from "./CustomerLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerLayout.vue?vue&type=script&setup=true&lang=js"

import "./CustomerLayout.vue?vue&type=style&index=0&id=71ef4f5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ef4f5b"]])

export default __exports__